<template>
  <div
    v-if="settings"
    :class="['flex flex-wrap', listClass.length ? listClass : 'mt-2']"
  >
    <h6
      v-for="(item, i) in tags"
      :id="'tag-' + item"
      :key="i"
      class="relative mr-4 mb-2 tag-item"
      :class="[textWhite ? 'text-white' : 'text-truegray-500']"
    >
      {{ item }}
    </h6>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    tags: { default: false },
    textWhite: { default: false },

    listClass: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),
  },
}
</script>

<style scoped>
.tag-item::after {
  position: absolute;
  right: -0.5rem;
  top: 50%;
  content: '';
  background: currentColor;
  height: 4px;
  width: 2px;
  border-radius: 6px;
  transform: translateY(-50%);
}

.tag-item:last-child::after {
  opacity: 0;
}
</style>
